import { createFileRoute } from "@tanstack/react-router";
import { useRecordTypeDrawerContext } from "@/utils/record-type-detail/record-type-drawer-context";
import { RecordTypeActivitySection } from "./fullActivity";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/activity",
)({
	component: OrgRecordTypeActivityTab,
});

function OrgRecordTypeActivityTab() {
	const { recordType } = useRecordTypeDrawerContext();

	return (
		<div className="p-4">
			<RecordTypeActivitySection recordType={recordType} />
		</div>
	);
}
